import { RoiScheduleRateResp } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import dayjs from 'dayjs';

const rates = [0.97, 0.99, 0.98, 0, 0.85, 0.94];
const weaveAverages = [0.5, 0.6, 0.55, 0.26, 0.65, 0.75];

const last6Months = Array.from({ length: 6 }, (_, i) => i)
  .map((i) => {
    return dayjs()
      .subtract(i + 1, 'month')
      .format('MMM');
  })
  .reverse();

export const appointmentsScheduleRate = (): RoiScheduleRateResp => {
  return {
    data: {
      dates: last6Months.map((month, index) => {
        return {
          key: month,
          rate: rates[index],
          weaveAverage: weaveAverages[index],
        };
      }),
      rateDifference: -0.0141,
      timePeriod: 'month',
      weaveAverage: 0.85,
    },
    message: '',
  };
};
